import React from 'react';
import ItemList from '../../../components/item-list/ItemList';

const PaymentsPayableTable = ({
  payments,
  selectedPayments,
  onSelectAll,
  onSelectPayment,
  onToggleExpand,
  onDeleteSelected,
  onEdit,
  onViewFiles,
  onSchedulePayment,
  onRecordPayment,
  onEditDeductions,
  canSelect = true,
  canDelete = true,
  canEdit = true,
  currentPage,
  onPageChange,
  totalItems,
  itemsPerPage
}) => {
  const columns = [
    { key: 'carrierCompanyName', label: 'Company Name' },
    { key: 'orderId', label: 'Order ID' },
    { key: 'carrierRate', label: 'Carrier Rate' },
    { key: 'totalAmount', label: 'Total Amount' },
    { key: 'status', label: 'Status' },
    { key: 'daysOnHold', label: 'Days Waiting' },
    { key: 'actions', label: 'Actions' }
  ];

  // Transform payments data for ItemList
  const transformedPayments = payments.map(payment => {
    const carrier = payment.carrier || {};
    const carrierAddress = carrier.address || {};
    const load = payment.load || {};
    
    // Days on Hold: from server data (counter starts on on Hold/received, stops on payed)
    const daysOnHoldValue = payment.daysOnHold !== null && payment.daysOnHold !== undefined
      ? `${payment.daysOnHold} ${payment.daysOnHold === 1 ? 'day' : 'days'}`
      : '—';
    return {
      ...payment,
      // Company Name from carrier.companyName
      

      carrierCompanyName: carrier.companyName || carrier.name || 'N/A',
      
      // Order ID from load.orderId
      orderId: payment.orderId || 'N/A',
      
      // Address from carrier.address.address
      carrierAddress: carrierAddress.address || 'N/A',
      
      // City from carrier.address.city
      carrierCity: carrierAddress.city || 'N/A',
      
      // Zip from carrier.address.zipCode or zip
      carrierZip: carrierAddress.zipCode || carrierAddress.zip || 'N/A',
      
      // Original Carrier Rate (not total)
      carrierRate: load.carrierRate ?? payment.carrierRate ?? null,
      
      // Bank from payment.bank (top level, not in carrier)
      bankName: payment.bank || 'N/A',
      
      // Routing Number from payment.routing (top level)
      routingNumber: payment.routing || 'N/A',
      
      // Account Number from payment.accountNumber (top level)
      accountNumber: payment.accountNumber || 'N/A',
      
      // Status from server
      status: payment.status || 'pending',
      statusBadge: payment.status || 'pending',
      
      // Days on Hold - counter from server
      daysOnHold: daysOnHoldValue,
      daysOnHoldRaw: payment.daysOnHold,
      
      // Total Amount (server if available, otherwise calculate)
      totalAmount: (() => {
        if (payment.totalAmount !== null && payment.totalAmount !== undefined) {
          return payment.totalAmount;
        }
        const baseRate = parseFloat(load.carrierRate ?? payment.carrierRate ?? 0) || 0;
        const fees = Array.isArray(payment.fees) ? payment.fees : [];
        const feesTotal = fees.reduce((sum, fee) => {
          return sum + (parseFloat(fee.carrierRate || fee.total || 0) || 0);
        }, 0);
        const tonuAmount = (payment.tonu?.enabled && payment.tonu?.carrierRate)
          ? parseFloat(payment.tonu.carrierRate) || 0
          : 0;
        return baseRate + feesTotal + tonuAmount;
      })(),

      // Keep original data for expanded view
      carrier: carrier,
      load: load
    };
  });

  return (
    <ItemList
      items={transformedPayments}
      itemType="paymentsPayable"
      selectedItems={selectedPayments}
      onSelectAll={onSelectAll}
      onSelectItem={onSelectPayment}
      onToggleExpand={onToggleExpand}
      onDeleteSelected={onDeleteSelected}
      onEdit={onEdit}
      onViewFiles={onViewFiles}
      canSelect={canSelect}
      canDelete={canDelete}
      canEdit={canEdit}
      onSchedulePayment={onSchedulePayment}
      onRecordPayment={onRecordPayment}
      onEditDeductions={onEditDeductions}
      currentPage={currentPage}
      onPageChange={onPageChange}
      totalItems={totalItems}
      itemsPerPage={itemsPerPage}
      columns={columns}
      isServerPaginated={true}
    />
  );
};

export default PaymentsPayableTable;
